import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=59a2d20a&"
import script from "./ProductInventory.vue?vue&type=script&lang=ts&"
export * from "./ProductInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports